import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { useCaseStudyContent } from '../../hooks/useCaseStudyContent';
import styles from './CaseStudyCard.module.css';

interface CaseStudyCardProps {
  slug: string;
  accentColor?: string;
}

const CaseStudyCard: React.FC<CaseStudyCardProps> = ({ slug, accentColor }) => {
  const { t } = useTranslation();
  const { data, loading } = useCaseStudyContent(slug);

  if (loading || !data) return null;

  return (
    <article className={styles.card}>
      <div className={styles.accentBar} style={{ backgroundColor: accentColor }} />
      {/*<div className={styles.images}>
        <div className={styles.imageGroup}>
          <span className={styles.imageLabel}>{t('caseStudies.before')}</span>
          <img src={data.beforeImage} alt={`${data.name} - ${t('caseStudies.before')}`} className={styles.image} />
        </div>
        <div className={styles.imageGroup}>
          <span className={styles.imageLabel}>{t('caseStudies.after')}</span>
          <img src={data.afterImage} alt={`${data.name} - ${t('caseStudies.after')}`} className={styles.image} />
        </div>
      </div>*/}
      <div className={styles.content}>
        <h3 className={styles.name} style={{ color: accentColor }}>
          {data.name}
        </h3>
        <p className={styles.breed}>{data.breed}</p>
        <p className={styles.summary}>{data.summary}</p>
        <div className={styles.story}>
          <ReactMarkdown>{data.story}</ReactMarkdown>
        </div>
        <div className={styles.outcome}>
          <strong>{t('caseStudies.outcome')}:</strong> {data.outcome}
        </div>
      </div>
    </article>
  );
};

export default CaseStudyCard;
